import React from 'react';
import Settings from '../components/Settings';
import './SettingsPage.css';

const SettingsPage = ({ settings, setSettings, language, onNavigateHome }) => {
  return (
    <div className="settings-page">
      <Settings
        settings={settings}
        setSettings={setSettings}
        language={language}
        onNavigateHome={onNavigateHome}
      />
    </div>
  );
};

export default SettingsPage;